// extracted by mini-css-extract-plugin
export default {"container":"register_container__WkJ21","form":"register_form__W4Aqs","link":"register_link__TyBDl","text":"register_text__tFlqx"};